import { render, staticRenderFns } from "./ShippingInfoForm.vue?vue&type=template&id=65f2f3bb&"
import script from "./ShippingInfoForm.vue?vue&type=script&lang=js&"
export * from "./ShippingInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports